export const Countries = () => {
  return (
    <div className="container-fluid country overflow-hidden py-5">
      <div className="container">
        <div
          className="section-title text-center wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ marginBottom: "70px" }}
        >
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">COUNTRIES WE OFFER</h5>
          </div>
          <h1 className="display-5 mb-4">
            Immigration & visa services following Countries
          </h1>
          <p className="mb-0">
            We provide visa processing, air ticket booking, and manpower
            services with expertise and full experience, ensuring the fastest
            possible turnaround.
          </p>
        </div>
        <div className="row g-4 text-center">
          <div
            className="col-lg-6 col-xl-3 mb-5 mb-xl-0 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="country-item">
              <div className="rounded overflow-hidden">
                <img
                  src="img/country-1.jpg"
                  className="img-fluid w-100 rounded"
                  alt="Image"
                />
              </div>
              <div className="country-flag">
                <img
                  src="img/malaysia.png"
                  className="img-fluid rounded-circle"
                  alt="Image"
                />
              </div>
              <div className="country-name">
                <a href="#!" className="text-white fs-4">
                  Malaysia
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-xl-3 mb-5 mb-xl-0 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="country-item">
              <div className="rounded overflow-hidden">
                <img
                  src="img/country-2.jpg"
                  className="img-fluid w-100 rounded"
                  alt="Image"
                />
              </div>
              <div className="country-flag">
                <img
                  src="img/thailand.png"
                  className="img-fluid rounded-circle"
                  alt="Image"
                />
              </div>
              <div className="country-name">
                <a href="#!" className="text-white fs-4">
                  Thailand
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-xl-3 mb-5 mb-xl-0 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="country-item">
              <div className="rounded overflow-hidden">
                <img
                  src="img/country-3.jpg"
                  className="img-fluid w-100 rounded"
                  alt="Image"
                />
              </div>
              <div className="country-flag">
                <img
                  src="img/singapore.png"
                  className="img-fluid rounded-circle"
                  alt="Image"
                />
              </div>
              <div className="country-name">
                <a href="#!" className="text-white fs-4">
                  Singapore
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-xl-3 mb-5 mb-xl-0 wow fadeInUp"
            data-wow-delay="0.7s"
          >
            <div className="country-item">
              <div className="rounded overflow-hidden">
                <img
                  src="img/country-4.jpg"
                  className="img-fluid w-100 rounded"
                  alt="Image"
                />
              </div>
              <div className="country-flag">
                <img
                  src="img/maldive.jpg"
                  className="img-fluid rounded-circle"
                  alt="Image"
                />
              </div>
              <div className="country-name">
                <a href="#!" className="text-white fs-4">
                  Maldive
                </a>
              </div>
            </div>
          </div>
          <div className="col-12">
            <a
              className="btn btn-primary border-secondary rounded-pill py-3 px-5 wow fadeInUp"
              data-wow-delay="0.1s"
              href="#!"
            >
              More Countries
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
